(function () {
  'use strict';

  if (window.AxiomSellingPlan) return;

  var roots = new Set();

  function visibleVariant(root) {
    return root.querySelector('[data-selling-plan-variant]:not([hidden])');
  }

  function clearError(root) {
    var error = root && root.querySelector('[data-selling-plan-error]');
    if (!error) return;
    error.textContent = '';
    error.hidden = true;
  }

  function formForRoot(root) {
    var formId = root && root.dataset.sellingPlanFormId;
    return formId ? document.getElementById(formId) : null;
  }

  function syncPurchaseControls(root) {
    var form = formForRoot(root);
    if (!form) return;

    var valid = hasValidSelection(root);
    form.dataset.sellingPlanValid = valid ? 'true' : 'false';
    form.querySelectorAll('[data-atc-btn], [data-featured-atc], [data-qv-atc]').forEach(function (button) {
      if (!valid) {
        if (!button.hasAttribute('data-selling-plan-was-disabled')) {
          button.dataset.sellingPlanWasDisabled = button.disabled ? 'true' : 'false';
        }
        button.disabled = true;
        return;
      }
      if (button.hasAttribute('data-selling-plan-was-disabled')) {
        button.disabled = button.dataset.sellingPlanWasDisabled === 'true';
        delete button.dataset.sellingPlanWasDisabled;
      }
    });

    form.querySelectorAll('[data-dynamic-checkout], [data-featured-dynamic-checkout]').forEach(function (checkout) {
      checkout.classList.toggle('dynamic-checkout--disabled', !valid);
      checkout.dataset.sellingPlanDisabled = valid ? 'false' : 'true';
    });

    form.dispatchEvent(new CustomEvent('selling-plan:statechange', {
      bubbles: true,
      detail: { valid: valid }
    }));
  }

  function clearPurchaseControlState(root) {
    var form = formForRoot(root);
    if (!form) return;
    form.querySelectorAll('[data-selling-plan-was-disabled]').forEach(function (button) {
      delete button.dataset.sellingPlanWasDisabled;
    });
  }

  function showError(root) {
    var error = root && root.querySelector('[data-selling-plan-error]');
    if (error) {
      error.textContent = root.dataset.sellingPlanRequiredMessage || '';
      error.hidden = false;
    }
    var variant = visibleVariant(root);
    var focusTarget = variant && (
      variant.querySelector('[data-selling-plan-choice]:not(:disabled)') ||
      variant.querySelector('[data-selling-plan-toggle-subscription]')
    );
    if (focusTarget) focusTarget.focus({ preventScroll: true });
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hasValidSelection(root) {
    var variant = visibleVariant(root);
    if (!variant) return true;
    if (!variant.querySelector('[data-selling-plan-choice]')) return false;
    var selected = variant.querySelector('[data-selling-plan-choice]:checked:not(:disabled)');
    if (variant.dataset.requiresSellingPlan !== 'true') return Boolean(
      selected && (selected.dataset.sellingPlanType === 'one-time' || selected.value)
    );
    return Boolean(selected && selected.dataset.sellingPlanType === 'plan' && selected.value);
  }

  function selectedPlanId(form) {
    if (!form) return '';
    var input = form.querySelector('[data-selling-plan-input], [name="selling_plan"]');
    return input && input.value ? String(input.value) : '';
  }

  function allocationIds(variantState) {
    var allocations = variantState && variantState.sellingPlanAllocations;
    if (!Array.isArray(allocations)) return [];
    return allocations.map(function (allocation) {
      return String(allocation.sellingPlanId || allocation.selling_plan_id || allocation.id || '');
    }).filter(Boolean);
  }

  function validationMessage(root) {
    return root && root.dataset.sellingPlanRequiredMessage ||
      window.Axiom && window.Axiom.productStrings && window.Axiom.productStrings.sellingPlanRequired ||
      'Select a purchase option before adding this product.';
  }

  function validateVariant(form, variantState) {
    var root = rootForForm(form);
    var activeVariant = root && visibleVariant(root);
    var purchaseOptionsUnavailable = Boolean(activeVariant && !activeVariant.querySelector('[data-selling-plan-choice]'));
    var selectedChoice = activeVariant && activeVariant.querySelector('[data-selling-plan-choice]:checked:not(:disabled)');
    var purchaseOptionMissing = Boolean(activeVariant && !purchaseOptionsUnavailable && !selectedChoice);
    var planId = selectedPlanId(form);
    var requiresPlan = Boolean(variantState && (
      variantState.requiresSellingPlan === true || variantState.requiresSellingPlan === 'true'
    ));
    var ids = allocationIds(variantState);
    var valid = !purchaseOptionsUnavailable && !purchaseOptionMissing && (
      requiresPlan ? Boolean(planId && ids.indexOf(planId) !== -1) : !planId || ids.indexOf(planId) !== -1
    );

    if (valid) {
      if (root) clearError(root);
      return { valid: true, message: '', displayed: false };
    }
    if (root) showError(root);
    return { valid: false, message: validationMessage(root), displayed: Boolean(root) };
  }

  function rootForForm(form) {
    if (!form || !form.id) return null;
    return Array.prototype.find.call(document.querySelectorAll('[data-selling-plan-block]'), function (root) {
      return root.dataset.sellingPlanFormId === form.id && !root.querySelector('.selling-plan-block__editor-notice');
    }) || null;
  }

  function validateForm(form) {
    var root = rootForForm(form);
    if (!root || root.hidden || hasValidSelection(root)) {
      if (root) clearError(root);
      return true;
    }
    showError(root);
    return false;
  }

  function syncInput(root) {
    var variant = visibleVariant(root);
    var input = root.querySelector('[data-selling-plan-input]');
    var selected = variant && variant.querySelector('[data-selling-plan-choice]:checked');
    if (input) input.value = selected && selected.dataset.sellingPlanType === 'plan' ? selected.value : '';
    syncToggle(variant, selected);
    if (selected) clearError(root);
    syncPurchaseControls(root);
  }

  function syncToggle(variant, selected) {
    if (!variant) return;
    var subscriptionToggle = variant.querySelector('[data-selling-plan-toggle-subscription]');
    var details = variant.querySelector('[data-selling-plan-toggle-details]');
    if (!subscriptionToggle || !details) return;
    var subscriptionSelected = Boolean(selected && selected.dataset.sellingPlanType === 'plan');
    subscriptionToggle.classList.toggle('is-active', subscriptionSelected);
    subscriptionToggle.setAttribute('aria-expanded', subscriptionSelected ? 'true' : 'false');
    details.hidden = !subscriptionSelected;
  }

  function closeDropdown(dropdown, restoreFocus) {
    if (!dropdown) return;
    dropdown.classList.remove('is-open');
    var trigger = dropdown.querySelector('[data-selling-plan-dropdown-trigger]');
    var panel = dropdown.querySelector('[data-selling-plan-dropdown-panel]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
    if (restoreFocus && trigger) trigger.focus();
  }

  function closeOtherDropdowns(active) {
    document.querySelectorAll('[data-selling-plan-dropdown].is-open').forEach(function (dropdown) {
      if (dropdown !== active) closeDropdown(dropdown, false);
    });
  }

  function buildDropdown(root, select, index) {
    if (select.dataset.sellingPlanEnhanced === 'true') return;
    select.dataset.sellingPlanEnhanced = 'true';

    var dropdown = document.createElement('div');
    dropdown.className = 'selling-plan-dropdown';
    dropdown.dataset.sellingPlanDropdown = '';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'selling-plan-dropdown__trigger';
    trigger.dataset.sellingPlanDropdownTrigger = '';
    trigger.id = root.id + '-dropdown-' + index;
    trigger.setAttribute('aria-expanded', 'false');

    var triggerLabel = document.createElement('span');
    triggerLabel.className = 'selling-plan-dropdown__label';
    var triggerIcon = document.createElement('span');
    triggerIcon.className = 'selling-plan-dropdown__icon';
    triggerIcon.setAttribute('aria-hidden', 'true');
    var iconTemplate = root.querySelector('[data-selling-plan-dropdown-icon]');
    if (iconTemplate) triggerIcon.appendChild(iconTemplate.content.cloneNode(true));
    trigger.appendChild(triggerLabel);
    trigger.appendChild(triggerIcon);

    var panel = document.createElement('div');
    panel.className = 'selling-plan-dropdown__panel';
    panel.dataset.sellingPlanDropdownPanel = '';
    panel.id = trigger.id + '-panel';
    panel.setAttribute('role', 'listbox');
    panel.setAttribute('aria-labelledby', trigger.id);
    panel.setAttribute('data-lenis-prevent', '');
    panel.hidden = true;
    trigger.setAttribute('aria-controls', panel.id);

    Array.prototype.forEach.call(select.options, function (option) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'selling-plan-dropdown__option';
      button.dataset.sellingPlanDropdownOption = option.value;
      button.setAttribute('role', 'option');
      button.textContent = option.textContent.trim();
      panel.appendChild(button);
    });

    function update() {
      var selected = select.options[select.selectedIndex];
      triggerLabel.textContent = selected ? selected.textContent.trim() : '';
      panel.querySelectorAll('[data-selling-plan-dropdown-option]').forEach(function (button) {
        var active = button.dataset.sellingPlanDropdownOption === select.value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    trigger.addEventListener('click', function () {
      var opening = !dropdown.classList.contains('is-open');
      closeOtherDropdowns(dropdown);
      dropdown.classList.toggle('is-open', opening);
      trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
      panel.hidden = !opening;
    });

    panel.addEventListener('click', function (event) {
      var optionButton = event.target.closest('[data-selling-plan-dropdown-option]');
      if (!optionButton) return;
      select.value = optionButton.dataset.sellingPlanDropdownOption || '';
      select.dispatchEvent(new Event('change', { bubbles: true }));
      update();
      closeDropdown(dropdown, true);
    });

    select.addEventListener('change', update);
    select.insertAdjacentElement('afterend', dropdown);
    dropdown.appendChild(trigger);
    dropdown.appendChild(panel);
    update();
  }

  function bindRoot(root) {
    if (!root || root.dataset.sellingPlanBound === 'true') return;
    root.dataset.sellingPlanBound = 'true';
    roots.add(root);

    root.querySelectorAll('[data-selling-plan-select]').forEach(function (select, index) {
      buildDropdown(root, select, index);
      select.addEventListener('change', function () {
        var group = select.closest('[data-selling-plan-group]');
        var groupChoice = group && group.querySelector('[data-selling-plan-choice]');
        var selected = select.options[select.selectedIndex];
        if (groupChoice) {
          groupChoice.value = select.value;
          groupChoice.checked = true;
        }
        var price = group && group.querySelector('[data-selling-plan-current-price]');
        if (price && selected) price.textContent = selected.dataset.price || '';
        syncInput(root);
      });
    });

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-selling-plan-choice]')) syncInput(root);
    });
    root.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-selling-plan-toggle-subscription]');
      if (!toggle || !root.contains(toggle)) return;
      var variant = toggle.closest('[data-selling-plan-variant]');
      var plan = variant && variant.querySelector('[data-selling-plan-choice][data-selling-plan-type="plan"]');
      if (!plan) return;
      plan.checked = true;
      plan.dispatchEvent(new Event('change', { bubbles: true }));
    });
    syncInput(root);
  }

  function initialize(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    if (target.matches && target.matches('[data-selling-plan-block]')) bindRoot(target);
    target.querySelectorAll('[data-selling-plan-block]').forEach(bindRoot);
  }

  function syncWithin(scope, variantId) {
    if (!scope || !variantId) return;
    scope.querySelectorAll('[data-selling-plan-block]').forEach(function (root) {
      if (root.querySelector('.selling-plan-block__editor-notice')) return;
      var previousVariant = visibleVariant(root);
      var previousVariantId = previousVariant && previousVariant.dataset.sellingPlanVariant;
      var active = null;
      root.querySelectorAll('[data-selling-plan-variant]').forEach(function (variant) {
        var matches = variant.dataset.sellingPlanVariant === String(variantId);
        variant.hidden = !matches;
        if (matches) active = variant;
      });
      root.hidden = !active;
      if (active && previousVariantId !== String(variantId)) {
        clearPurchaseControlState(root);
        active.querySelectorAll('[data-selling-plan-choice]').forEach(function (choice) { choice.checked = false; });
        clearError(root);
      }
      syncInput(root);
    });
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-selling-plan-dropdown]')) closeOtherDropdowns(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-selling-plan-dropdown].is-open');
    if (open) closeDropdown(open, true);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !rootForForm(form) || validateForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('.shopify-payment-button, [data-shopify="payment-button"]');
    var form = checkout && checkout.closest('form');
    if (!checkout || !form || !rootForForm(form) || validateForm(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) initialize(node);
      });
    });
  });

  window.AxiomSellingPlan = {
    initialize: initialize,
    syncWithin: syncWithin,
    validateForm: validateForm,
    validateVariant: validateVariant
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
